import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow flex px-2 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass([
                'block w-full rounded-md border-gray-300 shadow-sm text-sm outline-none border min-h-[38px]',
                'webchat-transition focus:ring-2 focus:ring-gray-300 focus:border-transparent'
            ]),
      placeholder: "Escreva aqui a sua mensagem",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
      onKeyup: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"])),
        _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.autoResize && _ctx.autoResize(...args)), ["delete"]))
      ],
      onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.autoResize && _ctx.autoResize(...args)))
    }, null, 544), [
      [_vModelText, _ctx.message]
    ]),
    (_ctx.props.showButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "ml-2 text-white rounded-md px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition duration-300",
          style: _normalizeStyle([_ctx.buttonStyle, _ctx.hoverStyle]),
          onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hover(true))),
          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hover(false))),
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
        }, " Enviar ", 36))
      : _createCommentVNode("", true)
  ]))
}